// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alegreya+Sans:ital,wght@0,100;0,300;0,400;0,500;0,700;0,800;0,900;1,100;1,300;1,400;1,500;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: var(--middle-yellow-color);
  font-family: "Alegreya Sans", sans-serif;
  position: relative;

  margin: 0;
  display: flex;
  /* min-width: 320px; */
  min-height: 100vh;
}

:root {
  --orange-color: #ff6b00;
  --light-orange-color: #fa9f5e;
  --yellow-color: #ffb800;
  --middle-yellow-color: #ffe8ae;
  --light-yellow-color: #fff4d9;
  --brown-color: #8e3b00;
  --black-color: #000;
}

.linkNoUnderline {
  text-decoration: none;
  width: 100%;
}

.input-file input[type=file] {
  position: absolute;
  z-index: -1;
  opacity: 0;
  display: block;
  width: 0;
  height: 0;
}

.input-file span {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,kBAAkB;;EAElB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,cAAc;EACd,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans:ital,wght@0,100;0,300;0,400;0,500;0,700;0,800;0,900;1,100;1,300;1,400;1,500;1,700;1,800;1,900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: var(--middle-yellow-color);\n  font-family: \"Alegreya Sans\", sans-serif;\n  position: relative;\n\n  margin: 0;\n  display: flex;\n  /* min-width: 320px; */\n  min-height: 100vh;\n}\n\n:root {\n  --orange-color: #ff6b00;\n  --light-orange-color: #fa9f5e;\n  --yellow-color: #ffb800;\n  --middle-yellow-color: #ffe8ae;\n  --light-yellow-color: #fff4d9;\n  --brown-color: #8e3b00;\n  --black-color: #000;\n}\n\n.linkNoUnderline {\n  text-decoration: none;\n  width: 100%;\n}\n\n.input-file input[type=file] {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  display: block;\n  width: 0;\n  height: 0;\n}\n\n.input-file span {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
